import styles from "./DeliveryOptions.module.scss";

type Props = {
  index: number;
  headline: string;
  description: string;
  displayPrice: string;
};

export function DeliveryOption({
  index,
  headline,
  description,
  displayPrice,
}: Props) {
  return (
    <>
      <dt
        data-testid={`delivery:options:headline:${index}`}
        className={styles.headline}
      >
        {headline}
      </dt>
      <dd
        data-testid={`delivery:options:price:${index}`}
        className={styles.price}
      >
        {displayPrice}
      </dd>
      <dd
        data-testid={`delivery:options:description:${index}`}
        className={styles.description}
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </>
  );
}
